import router from './router';

const url = window.location.pathname;

router.resolve(url);